const c = {
  name: "Donut",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,14c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,14,20,14z M16,20c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4
			c0,2.2-1.8,4-4,4C17.8,24,16,22.2,16,20z"/>
		<path class="st0" d="M28.9,25l1.2-3.8l-1.9-0.6L27,24.4L28.9,25z"/>
		<path class="st0" d="M24.3,10.7l3.2,2.4l-1.2,1.6l-3.2-2.3L24.3,10.7z"/>
		<path class="st0" d="M15.7,10.7l-3.2,2.4l1.2,1.6l3.2-2.3L15.7,10.7z"/>
		<path class="st0" d="M11.1,25l-1.2-3.8l1.9-0.6l1.2,3.8L11.1,25z"/>
		<path class="st0" d="M18,28v2h4v-2H18z"/>
		<path class="st0" d="M16.8,5.4C17.6,4.8,18.6,4,20,4c1.3,0,2.4,0.8,3.2,1.5c0.2,0.2,0.4,0.3,0.5,0.4c0.2,0.2,0.4,0.4,0.7,0.5
			c0.4,0.3,0.7,0.5,1,0.6c0.3,0.1,0.7,0.2,1.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0.2,0,0.4,0,0.6,0.1c1,0.1,2.4,0.3,3.3,1.2
			c0.9,0.9,1.1,2.3,1.2,3.3c0,0.2,0,0.4,0.1,0.6l0,0c0,0.3,0.1,0.6,0.1,0.9c0.1,0.5,0.1,0.9,0.3,1.2c0.1,0.3,0.3,0.6,0.6,1
			c0.2,0.2,0.4,0.4,0.6,0.7c0.1,0.2,0.3,0.3,0.4,0.5c0.7,0.8,1.5,1.9,1.5,3.2c0,1.3-0.8,2.4-1.5,3.2c-0.2,0.2-0.3,0.4-0.4,0.5
			c-0.2,0.2-0.4,0.4-0.5,0.7c-0.3,0.4-0.5,0.7-0.6,1c-0.1,0.3-0.2,0.7-0.3,1.1c0,0.3-0.1,0.6-0.1,0.9l0,0c0,0.2,0,0.4-0.1,0.6
			c-0.1,1-0.3,2.4-1.2,3.3c-0.9,0.9-2.3,1.1-3.3,1.2c-0.2,0-0.4,0-0.6,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.5,0.1-0.9,0.1-1.2,0.3
			c-0.3,0.1-0.6,0.3-1,0.6c-0.2,0.2-0.4,0.4-0.7,0.6c-0.2,0.1-0.3,0.3-0.5,0.4C22.4,35.2,21.3,36,20,36c-1.3,0-2.4-0.8-3.2-1.5
			c-0.2-0.2-0.4-0.3-0.5-0.4l0,0c-0.2-0.2-0.4-0.4-0.7-0.5c-0.4-0.3-0.7-0.5-1-0.6c-0.3-0.1-0.7-0.2-1.1-0.3c-0.3,0-0.6-0.1-0.9-0.1
			l0,0l0,0l0,0c-0.2,0-0.4,0-0.6-0.1c-1-0.1-2.4-0.3-3.3-1.2c-0.9-0.9-1.1-2.3-1.2-3.3c0-0.2,0-0.4-0.1-0.6c0-0.3-0.1-0.6-0.1-0.9
			c-0.1-0.5-0.1-0.9-0.3-1.2c-0.1-0.3-0.3-0.6-0.6-1c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1-0.2-0.3-0.3-0.4-0.5C4.8,22.4,4,21.3,4,20
			c0-1.3,0.8-2.4,1.5-3.2c0.2-0.2,0.3-0.4,0.4-0.5c0.2-0.2,0.4-0.4,0.5-0.7c0.3-0.4,0.5-0.7,0.6-1c0.1-0.3,0.2-0.7,0.3-1.1
			c0-0.3,0.1-0.6,0.1-0.9c0-0.2,0-0.4,0.1-0.6c0.1-1,0.3-2.4,1.2-3.3c0.9-0.9,2.3-1.1,3.3-1.2c0.2,0,0.4,0,0.6-0.1
			c0.3,0,0.6-0.1,0.9-0.1c0.5-0.1,0.9-0.1,1.2-0.3c0.3-0.1,0.6-0.3,1-0.6c0.2-0.2,0.4-0.4,0.7-0.6C16.5,5.7,16.6,5.6,16.8,5.4z
			 M16.9,8c-0.4,0.3-0.9,0.7-1.5,0.9c-0.5,0.2-1.1,0.3-1.7,0.4c-0.3,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0c-1.1,0.1-1.7,0.3-2,0.6
			c-0.4,0.4-0.5,1-0.6,2.1c0,0.2,0,0.4,0,0.5c0,0.3-0.1,0.7-0.1,1c-0.1,0.5-0.2,1.1-0.4,1.7c-0.2,0.5-0.6,1-0.9,1.4
			c-0.2,0.2-0.4,0.5-0.6,0.8c-0.1,0.2-0.3,0.3-0.4,0.4c-0.7,0.8-1,1.4-1,1.9c0,0.6,0.3,1.1,1,1.9c0.1,0.1,0.2,0.3,0.3,0.4
			c0.2,0.3,0.5,0.5,0.7,0.8c0.3,0.4,0.7,0.9,0.9,1.5c0.2,0.5,0.3,1.1,0.4,1.7c0,0.3,0.1,0.7,0.1,1.1c0,0.2,0,0.4,0,0.5
			c0.1,1.1,0.3,1.7,0.6,2c0.4,0.4,1,0.5,2.1,0.6c0.2,0,0.4,0,0.5,0c0.3,0,0.7,0.1,1,0.1c0.5,0.1,1.1,0.2,1.7,0.4
			c0.5,0.2,1,0.6,1.4,0.9c0.2,0.2,0.5,0.4,0.8,0.6c0.2,0.1,0.3,0.3,0.4,0.4c0.8,0.7,1.4,1,1.9,1c0.6,0,1.1-0.3,1.9-1
			c0.1-0.1,0.3-0.2,0.4-0.3c0.3-0.2,0.5-0.5,0.8-0.7c0.4-0.3,0.9-0.7,1.5-0.9c0.5-0.2,1.1-0.3,1.7-0.4c0.3,0,0.7-0.1,1.1-0.1l0,0
			l0,0c0.2,0,0.4,0,0.5,0c1.1-0.1,1.7-0.3,2-0.6c0.4-0.4,0.5-1,0.6-2.1c0-0.2,0-0.4,0-0.5c0-0.3,0.1-0.7,0.1-1
			c0.1-0.5,0.2-1.1,0.4-1.7c0.2-0.5,0.6-1,0.9-1.4c0.2-0.2,0.4-0.5,0.6-0.8c0.1-0.2,0.3-0.3,0.4-0.4c0.7-0.8,1-1.4,1-1.9
			c0-0.6-0.3-1.1-1-1.9c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.3-0.5-0.5-0.7-0.8c-0.3-0.4-0.7-0.9-0.9-1.5c-0.2-0.5-0.3-1.1-0.4-1.7
			c0-0.3-0.1-0.7-0.1-1.1c0-0.2,0-0.4,0-0.5c-0.1-1.1-0.3-1.7-0.6-2c-0.4-0.4-1-0.5-2.1-0.6c-0.2,0-0.4,0-0.5,0
			c-0.3,0-0.7-0.1-1-0.1c-0.5-0.1-1.1-0.2-1.7-0.4c-0.5-0.2-1-0.6-1.4-0.9c-0.2-0.2-0.5-0.4-0.8-0.6c-0.2-0.1-0.3-0.3-0.4-0.4
			c-0.8-0.7-1.4-1-1.9-1c-0.6,0-1.1,0.3-1.9,1c-0.1,0.1-0.3,0.2-0.4,0.3l0,0C17.4,7.6,17.1,7.8,16.9,8z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20s20-9,20-20C40,9,31,0,20,0z M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18
			c0,9.9-8.1,18-18,18S2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Donut
};
